

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { partnersReferralStatuses } from '../statuses';

export default class PartnersReferralsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'partners-referrals';
        this.Server = this.props.context.getState().server.partnersReferrals;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'code'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'inviterId',
                label: 'inviter',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'inviter',
                show: 'email'
            },
            {
                id: 'inviteeId',
                label: 'invitee',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'invitee',
                show: 'email'
            },
            {
                id: 'code',
                label: 'code',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(partnersReferralStatuses)
            },
            {
                id: 'blockReason',
                label: 'blockReason',
                alignRight: false,
                cell: 'Text',
                displayGrid: false,
                displayDialogDetails: true
            },
            {
                id: 'dateSignedUp',
                label: 'dateSignedUp',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateActivated',
                label: 'dateActivated',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateBlocked',
                label: 'dateBlocked',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: false,
                displayDialogDetails: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}